import InputView from './input-view'

export default InputView
